import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import React from 'react';
import styled from 'styled-components';
import variables from '@ingka/variables/design-tokens';
import { OnboardingItem } from './OnboardingItem';
import StepIcons from '../images/StepIcons';
import { useOnboarding } from '../hooks/useOnboarding';
import TMarkUp from './TMarkUp';
import { getImage, IGatsbyImageData } from 'gatsby-plugin-image';

const StyledOnboardingItems = styled.ol`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${`@media (min-width: ${variables.breakpointM}) {
    flex-direction: row;
    flex-wrap: wrap;
    min-height: 500px;
    gap: 17px;
  }`}
  list-style-type: none;
`;

const IconsWrapper = styled.div`
  padding-bottom: 5px;
`;

export const Onboarding = (): JSX.Element => {
  const { t } = useTranslation();
  const { onboarding, items } = useOnboarding();

  const onboardingItems = items.map((item, index) => {
    const step = index + 1;
    const image = getImage(
      item.image.childImageSharp.gatsbyImageData
    ) as IGatsbyImageData;
    const captionId = `onboarding-image-${step}`;
    return (
      <OnboardingItem key={step} imgSrc={image} captionId={captionId}>
        <IconsWrapper>
          <StepIcons step={step} />
        </IconsWrapper>
        <p id={captionId}>
          <TMarkUp value={t(`spareParts.onboarding.steps.${step}`)} />
        </p>
      </OnboardingItem>
    );
  });

  const onboardingImage = getImage(
    onboarding.image.childImageSharp.gatsbyImageData
  ) as IGatsbyImageData;

  return (
    <div>
      <h2 className="h3">
        <TMarkUp value={t(`spareParts.onboarding.title`)} />
      </h2>
      <StyledOnboardingItems>
        <OnboardingItem imgSrc={onboardingImage} captionId="onboarding-info">
          <p id="onboarding-info">
            <TMarkUp value={t(`spareParts.onboarding.info`)} />
          </p>
        </OnboardingItem>
        {onboardingItems}
      </StyledOnboardingItems>
    </div>
  );
};
